import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { CaiMaintenanceComponent } from './components/cai-maintenance/cai-maintenance.component';
import { CreateRemitoComponent } from './components/create-remito/create-remito.component';
import { CreateVehicleRemitoComponent } from './components/create-vehicle-remito/create-vehicle-remito.component';
import {
  DestinatarioMaintenanceComponent
} from './components/destinatario-maintenance/destinatario-maintenance.component';
import { DockMaintenanceComponent } from './components/dock-maintenance/dock-maintenance.component';
import { HomeComponent } from './components/home/home.component';
import { ImpresoraMaintenanceComponent } from './components/impresora-maintenance/impresora-maintenance.component';
import { IssuedRemitosReportComponent } from './components/issued-remitos-report/issued-remitos-report.component';
import { MgoErrorProcessingComponent } from './components/mgo-error-processing/mgo-error-processing.component';
import { OpenItemsReportComponent } from './components/open-items-report/open-items-report.component';
import {OtdsErrorRootComponent} from './components/otds-error-screen/otds-error-root/otds-error-root.component';
import { ReasonCodeMaintenanceComponent } from './components/reason-code-maintenance/reason-code-maintenance.component';
import {SchedulerStatusComponent} from './components/scheduler-status/scheduler-status.component';
import {
  SolicitanteMaintenanceComponent
} from './components/solicitante-maintenance/solicitante-maintenance.component';
import { TpreMaintenanceComponent } from './components/tpre-maintenance/tpre-maintenance.component';
import { TransporteMaintenanceComponent } from './components/transporte-maintenance/transporte-maintenance.component';
import { UserMaintenanceComponent } from './components/user-maintenance/user-maintenance.component';
import {
  VehicleDestinoTransportistaMaintenanceComponent
} from './components/vehicle-destino-transportista-maintenance/vehicle-destino-transportista-maintenance.component';
import {ViewVehicleRemitosComponent } from './components/view-vehicle-remitos/view-vehicle-remitos.component';
import { ViewRemitosComponent } from './components/view-remitos/view-remitos.component';
import { AuthGaurdService } from './services/auth-gaurd.service';
import { DeactivateGuardService } from './services/deactivate-guard.service';
import {VehicleOnholdReleaseComponent} from "./components/vehicle-onhold-release/vehicle-onhold-release.component";
import {VehicleRemitosPrintedComponent} from "./components/vehicle-remitos-printed/vehicle-remitos-printed.component";

const routes: Routes = [
  {
    path:'home',
    component: HomeComponent
  },
  {
    path: 'create-remito',
    component: CreateRemitoComponent,
    canActivate: [AuthGaurdService],
    data: {
      roles: ['Admin','Espectador','Creator']
    }
  },
  {
    path: 'create-remito/:ptoEmision/:remitoNum',
    component: CreateRemitoComponent,
    data: {
      roles: ['Admin','Espectador','Creator']
    }
  },
  {
    path: 'create-vehicle-remito',
    component: CreateVehicleRemitoComponent,
    canActivate: [AuthGaurdService],
    data: {
      roles: ['Vehicle']
    }
  },
  {
    path: 'create-vehicle-remito/:ptoEmision/:remitoNum',
    component: CreateVehicleRemitoComponent,
    data: {
      roles: ['Vehicle']
    }
  },
  {
    path: 'view-remito',
    component: ViewRemitosComponent,
    canActivate: [AuthGaurdService],
    data: {
      roles: ['Admin','Espectador','Creator']
    }
  },
  {
    path: 'mgo-error-processing',
    component: MgoErrorProcessingComponent,
    canActivate: [AuthGaurdService],
    data: {
      roles: ['Admin','Espectador','Creator']
    }
  },
  {
    path: 'otds-error-processing',
    component: OtdsErrorRootComponent,
    canActivate: [AuthGaurdService],
    data: {
      roles: ['vehicle']
    }
  },
  {
    path: 'issued-remitos-report',
    component: IssuedRemitosReportComponent,
    canActivate: [AuthGaurdService],
    data: {
      roles: ['Admin','Espectador','Creator']
    }
  },
  {
    path: 'free_open_remitos',
    component: OpenItemsReportComponent,
    canActivate: [AuthGaurdService],
    data: {
      roles: ['Admin','Espectador','Creator']
    }
  },
  {
    path: 'user-maintenance',
    component: UserMaintenanceComponent,
    canDeactivate: [DeactivateGuardService],
    canActivate: [AuthGaurdService],
    data: {
      roles: ['Admin','Espectador','Creator','Vehicle']
    }
  },
  {
    path: 'dock-maintenance',
    component: DockMaintenanceComponent,
    canDeactivate: [DeactivateGuardService],
    canActivate: [AuthGaurdService],
    data: {
      roles: ['Admin','Espectador','Creator']
    }
  },
  {
    path: 'reason-code-maintenance',
    component: ReasonCodeMaintenanceComponent,
    canDeactivate: [DeactivateGuardService],
    canActivate: [AuthGaurdService],
    data: {
      roles: ['Admin','Espectador','Creator']
    }
  },
  {
    path: 'transporte-maintenance',
    component: TransporteMaintenanceComponent,
    canDeactivate: [DeactivateGuardService],
    canActivate: [AuthGaurdService],
    data: {
      roles: ['Admin','Espectador','Creator','Vehicle']
    }
  },
  {
    path: 'destinatario-maintenance',
    component: DestinatarioMaintenanceComponent,
    canDeactivate: [DeactivateGuardService],
    canActivate: [AuthGaurdService],
    data: {
      roles: ['Admin','Espectador','Creator','Vehicle']
    }
  },
  {
    path: 'solicitante-maintenance',
    component: SolicitanteMaintenanceComponent,
    canDeactivate: [DeactivateGuardService],
    canActivate: [AuthGaurdService],
    data: {
      roles: ['Admin','Espectador','Creator']
    }
  },
  {
    path: 'cai-maintenance',
    component: CaiMaintenanceComponent,
    canDeactivate: [DeactivateGuardService],
    canActivate: [AuthGaurdService],
    data: {
      roles: ['CAI_Editor']
    }
  },
  {
    path: 'view-vehicle-remitos',
    component: ViewVehicleRemitosComponent,
    canActivate: [AuthGaurdService],
    data: {
      roles: ['Vehicle']
    }
  },
  {
    path: 'destino-transportista-maintenance',
    component: VehicleDestinoTransportistaMaintenanceComponent,
    canDeactivate: [DeactivateGuardService],
    canActivate: [AuthGaurdService],
    data: {
      roles: ['Vehicle']
    }
  },

  {
    path: 'impresoras-maintenance',
    component: ImpresoraMaintenanceComponent,
    canDeactivate: [DeactivateGuardService],
    canActivate: [AuthGaurdService],
    data: {
      roles: ['Vehicle']
    }
  },
  {
   path: 'tpre-maintenance',
   component: TpreMaintenanceComponent,
   canDeactivate: [DeactivateGuardService],
   canActivate: [AuthGaurdService],
    data: {
      roles: ['Vehicle']
    }
  },
  {
    path: 'liberar-vta-directa',
    component: VehicleOnholdReleaseComponent,
    canActivate: [AuthGaurdService],
    data: {
      roles: ['Vehicle']
    }
  },
  {
    path: 'vehicle-printed-remitos',
    component: VehicleRemitosPrintedComponent,
    canActivate: [AuthGaurdService],
    data: {
      roles: ['Vehicle']
    }
  },
  {
    path: 'scheduled-task-status',
    component: SchedulerStatusComponent,
    canActivate: [AuthGaurdService],
    data: {
      roles: ['Admin', 'Vehicle']
    }
  },


    {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes,{useHash: true}), FormsModule, ReactiveFormsModule],
  exports: [RouterModule]
})
export class AppRoutingModule { }
